import { COMPONENTS, DeepPartial, SearchBoxConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_SEARCH_BOX: DeepPartial<SearchBoxConfig> = {
  autoCompleteEnabled: false,
  autofocus: true,
  components: {
    clearButtonContent: 'CdlSearchBoxClear',
    icon: null,
  }
};

export const DESKTOP_SEARCH_BOX: DeepPartial<SearchBoxConfig> = {
  components: {
    icon: 'CdlSearchIcon',
    placeholder: COMPONENTS.PURE.SearchBoxPlaceholder
  }
};
